export enum Gender {
  male = "Мужской",
  female = "Женский"
}

export const rejectCandidateProfileStatuses = [9, 10];
export const sourceResources = [49, 95];
